module.exports = __webpack_public_path__ + "static/img/bubble-bg.3e0cf717.png";